'use strict';
import { environment } from '@environments/environment';

printSendARInvoiceController.$inject = [
	'$scope',
	'$rootScope',
	'$q',
	'$uibModal',
	'$interval',
	'dialogHelper',
	'arInvoiceService',
	'authInterceptorService',
	'authService',
	'USER_CLAIMS',
	'BUSY_MESSAGE',
];
angular.module('schoolLinqApp').controller('printSendARInvoiceController', printSendARInvoiceController);

function printSendARInvoiceController(
	$scope,
	$rootScope,
	$q,
	$uibModal,
	$interval,
	dialogHelper,
	arInvoiceService,
	authInterceptorService,
	authService,
	USER_CLAIMS,
	BUSY_MESSAGE
) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.$watch(
		'vm.filteredInvoices',
		function (arInvoices) {
			var selectedItems = 0;
			var totalItems = 0;

			$scope.vm.filter.numberOfSelectedItemsPrint = 0;
			$scope.vm.filter.numberOfSelectedItemsEmail = 0;

			for (var index = 0; index < arInvoices.length; index++) {
				if (arInvoices[index].Status === $scope.vm.statusEnum.AwaitingSend) {
					totalItems++;
				}

				if (arInvoices[index].Selected && arInvoices[index].Status === $scope.vm.statusEnum.AwaitingSend) {
					selectedItems++;

					if (arInvoices[index].DeliveryMethod === $scope.vm.deliveryMethodEnum.Print) {
						$scope.vm.filter.numberOfSelectedItemsPrint++;
					} else {
						$scope.vm.filter.numberOfSelectedItemsEmail++;
					}
				}
			}

			$scope.vm.filter.numberOfSelectedItems = selectedItems;

			if (selectedItems === totalItems) {
				$scope.vm.filter.allSelected = true;
			} else {
				$scope.vm.filter.allSelected = false;
			}
		},
		true
	);

	$q.all([$scope.vm.loadArInvoices($scope.vm)]);

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,

			arInvoices: [],
			filteredInvoices: [],
			filter: {
				search: '',
				status: 'Not Printed/Emailed',
				deliveryMethod: 'All',
				numberOfSelectedItems: 0,
				numberOfSelectedItemsPrint: 0,
				numberOfSelectedItemsEmail: 0,
				allSelected: false,
				propertyName: 'Id',
				reverse: false,
			},
			viewArInvoice: {
				images: [],
				activeImage: 0,
				readOnly: false,
			},
			pageSize: 12,
			startIndex: 0,
			printVendorCopy: false,
			printCopyTwo: false,
			printCopyThree: false,
			statusEnum: {
				AwaitingSend: 'Not Printed/Emailed',
				Sent: 'Printed/Emailed',
			},
			deliveryMethodEnum: {
				Print: 'Print',
				Email: 'Email',
				All: 'All',
			},
			sendStatus: [],
			sendStatusEmailsFailed: 0,
			sendStatusPrintsFailed: 0,
			sendStatusPageSize: 12,
			sendStatusStartIndex: 0,
			busyPromise: null,
			busyMessage: BUSY_MESSAGE.Loading,
			errors: null,
			isReadOnly: authService.isReadOnly(USER_CLAIMS.lsb, 'PrintEmail', 'receivable'),
		};

		function loadArInvoices(model) {
			model.busyMessage = BUSY_MESSAGE.Loading;
			model.busyPromise = arInvoiceService.getArInvoicesForSend().then(_.partial(finishLoadingArInvoices, model));

			function finishLoadingArInvoices(model, response) {
				model.arInvoices = response.data.arInvoices;

				for (let index = 0; index < model.arInvoices.length; index++) {
					if (model.arInvoices[index].Status !== model.statusEnum.Sent) {
						model.arInvoices[index].Selected = true;
					} else {
						model.arInvoices[index].Selected = false;
					}
				}

				return angular.noop;
			}
		}

		function selectAllInvoices(model) {
			let setValue;
			if (model.filter.allSelected) {
				setValue = false;
			} else {
				setValue = true;
			}

			model.filter.allSelected = setValue;

			for (let index = 0; index < model.filteredInvoices.length; index++) {
				if (model.filteredInvoices[index].Status === model.statusEnum.AwaitingSend) {
					model.filteredInvoices[index].Selected = setValue;
				}
			}
		}

		function filterInvoices(model, invoice) {
			if (
				invoice.Status === model.filter.status &&
				(invoice.DeliveryMethod === model.filter.deliveryMethod || model.filter.deliveryMethod === model.deliveryMethodEnum.All)
			) {
				return true;
			} else {
				return false;
			}
		}

		function openInvoice(model, invoiceId) {
			model.errors = '';
			$uibModal
				.open({
					windowClass: 'app-modal-documentpreview',
					template: require('@ajs/templates/fund/accountReceivable/invoice-emailprint-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$q',
						'$uibModalInstance',
						'arInvoiceService',
						function ($scope, $q, modalInstance, arInvoiceService) {
							$q.all([getPreview($scope.vm)]);

							function getPreview(model) {
								model.busyMessage = BUSY_MESSAGE.Loading;
								model.busyPromise = arInvoiceService
									.getArInvoiceImagePreview(invoiceId)
									.then(_.partial(finishedGettingPreview, model));

								function finishedGettingPreview(model, response) {
									$scope.vm.viewArInvoice.images = response.data.images;
									$scope.vm.viewArInvoice.activeImage = 0;
									return angular.noop;
								}
							}

							angular.extend($scope, {
								getPreview: _.partial(getPreview, model),
								cancel: function () {
									modalInstance.close(true);
								},
								sendEmail: function () {
									var arInvoiceToSend = [invoiceId];

									model.busyMessage = BUSY_MESSAGE.SendingEmail;
									model.busyPromise = arInvoiceService.emailArInvoice(arInvoiceToSend).then(function (response) {
										if (response.data.numberFailed > 0) {
											$scope.vm.errors = 'The Invoice failed to send via Email.';
										}

										modalInstance.close(true);
									});
								},
								print: function () {
									$scope.isReportFinished = false;
									model.busyMessage = BUSY_MESSAGE.Loading;
									$scope.vm.busyPromise = $scope.reportInterval = $interval(function () {
										if ($scope.isReportFinished) {
											$interval.cancel($scope.reportInterval);
											$scope.isReportFinished = false;
										}
									}, 1000);

									var arInvoiceIdsToPrint = [invoiceId];

									var url = environment.API_URL + '/api/arinvoice/printarinvoice';

									// Load the PDF via AJAX request. This allows us to check if the request was successful.
									var xhr = new XMLHttpRequest();
									xhr.open('POST', url, true);
									xhr.responseType = 'blob';
									xhr.setRequestHeader('Authorization', authInterceptorService.bearerToken());
									xhr.setRequestHeader('Content-type', 'application/json');

									xhr.onload = function (oEvent) {
										if (xhr.status === 200) {
											var blob = new Blob([xhr.response], {
												type: 'application/pdf',
											});

											// IE (as of 11) doesn't allow window.open with Blobs, so we use their native method.
											if (window.navigator.msSaveOrOpenBlob) {
												window.navigator.msSaveOrOpenBlob(blob, 'Invoice.pdf');
											} else {
												let bloburl = URL.createObjectURL(blob);
												window.open(bloburl);
											}
											$scope.isReportFinished = true;
										} else {
											let msgList = [];
											if (xhr.status === 204) {
												msgList.push('No data available for this request!');
											} else {
												msgList.push('An error occurred during the request.');
												msgList.push('If the problem continues, please contact your Administrator!');
											}
											$scope.isReportFinished = true;
											dialogHelper.openMessageBox('Report Message', null, msgList, 'Warning');
										}

										modalInstance.close(true);
									};

									xhr.send(JSON.stringify(arInvoiceIdsToPrint));
								},
							});
						},
					],
				})
				.result.then(function (reload) {
					$scope.vm.viewArInvoice.activeImage = 0;

					if (reload) {
						return $scope.vm.loadArInvoices();
					}
				});
		}

		function confirmSendInvoices(model) {
			model.errors = '';
			$uibModal.open({
				template: require('@ajs/templates/fund/accountReceivable/invoice-confirmsend-modal.html'),
				backdrop: 'static',
				keyboard: false,
				scope: $scope,
				controller: [
					'$scope',
					'$uibModalInstance',
					function ($scope, modalInstance) {
						angular.extend($scope, {
							cancel: function () {
								modalInstance.close();
							},
							send: function () {
								modalInstance.close();
								model.sendSelected();
							},
						});
					},
				],
			});
		}

		function sendSelected(model) {
			model.errors = '';
			// Send the emails.
			var arInvoiceIdsToEmail = [];
			var arInvoiceIdsToPrint = [];
			for (var index = 0; index < model.filteredInvoices.length; index++) {
				if (model.filteredInvoices[index].Selected) {
					if (model.filteredInvoices[index].DeliveryMethod === model.deliveryMethodEnum.Email) {
						arInvoiceIdsToEmail.push(model.filteredInvoices[index].Id);
					} else {
						arInvoiceIdsToPrint.push(model.filteredInvoices[index].Id);
					}
				}
			}

			if (arInvoiceIdsToEmail.length > 0) {
				model.busyMessage = BUSY_MESSAGE.SendingEmail;
				model.busyPromise = arInvoiceService.emailArInvoice(arInvoiceIdsToEmail).then(_.partial(openPrintableInvoices, model));
			} else {
				openPrintableInvoices();
			}

			function openPrintableInvoices() {
				// Then open the printable invoices.
				if (arInvoiceIdsToPrint.length === 0) {
					model.displaySendStatus(arInvoiceIdsToPrint, arInvoiceIdsToEmail);
					model.loadArInvoices();
				} else {
					$scope.isReportFinished = false;
					model.busyMessage = BUSY_MESSAGE.Loading;
					$scope.vm.busyPromise = $scope.reportInterval = $interval(function () {
						if ($scope.isReportFinished) {
							$interval.cancel($scope.reportInterval);
							$scope.isReportFinished = false;
						}
					}, 1000);

					var url = environment.API_URL + '/api/arinvoice/printarinvoice';

					// Load the PDF via AJAX request. This allows us to check if the request was successful.
					var xhr = new XMLHttpRequest();
					xhr.open('POST', url, true);
					xhr.responseType = 'blob';
					xhr.setRequestHeader('Authorization', authInterceptorService.bearerToken());
					xhr.setRequestHeader('Content-type', 'application/json');

					xhr.onload = function (oEvent) {
						if (xhr.status === 200) {
							var blob = new Blob([xhr.response], { type: 'application/pdf' });

							// IE (as of 11) doesn't allow window.open with Blobs, so we use their native method.
							if (window.navigator.msSaveOrOpenBlob) {
								window.navigator.msSaveOrOpenBlob(blob, 'Invoice.pdf');
							} else {
								let bloburl = URL.createObjectURL(blob);
								window.open(bloburl);
							}
							$scope.isReportFinished = true;
						} else {
							let msgList = [];
							if (xhr.status === 204) {
								msgList.push('No data available for this request!');
							} else {
								msgList.push('An error occurred during the request.');
								msgList.push('If the problem continues, please contact your Administrator!');
							}
							$scope.isReportFinished = true;
							dialogHelper.openMessageBox('Report Message', null, msgList, 'Warning');
						}

						model.displaySendStatus(arInvoiceIdsToPrint, arInvoiceIdsToEmail);
						model.loadArInvoices();
					};

					xhr.send(JSON.stringify(arInvoiceIdsToPrint));
				}
			}
		}

		function displaySendStatus(model, arInvoicesToPrint, arInvoicesToEmail) {
			var combinedInvoices = {
				EmailedIds: arInvoicesToEmail,
				PrintedIds: arInvoicesToPrint,
			};

			arInvoiceService.checkInvoiceSendStatus(combinedInvoices).then(_.partial(doneCheckingStatus, model));

			function doneCheckingStatus(model, response) {
				model.sendStatus = response.data.failures;
				model.sendStatusEmailsFailed = model.sendStatus.filter(function (value) {
					return value.DeliveryMethod === model.deliveryMethodEnum.Email;
				}).length;

				model.sendStatusPrintsFailed = model.sendStatus.filter(function (value) {
					return value.DeliveryMethod === model.deliveryMethodEnum.Print;
				}).length;

				$uibModal.open({
					template: require('@ajs/templates/fund/accountReceivable/invoice-sendsummary-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						function ($scope, modalInstance) {
							angular.extend($scope, {
								done: function () {
									modalInstance.close();
								},
							});
						},
					],
				});
			}
		}

		function sortby(model, propertyName) {
			model.filter.reverse = model.filter.propertyName === propertyName ? !model.filter.reverse : false;
			model.filter.propertyName = propertyName;
		}

		return angular.extend(model, {
			loadArInvoices: _.partial(loadArInvoices, model),
			selectAllInvoices: _.partial(selectAllInvoices, model),
			filterInvoices: _.partial(filterInvoices, model),
			openInvoice: _.partial(openInvoice, model),
			sendSelected: _.partial(sendSelected, model),
			confirmSendInvoices: _.partial(confirmSendInvoices, model),
			displaySendStatus: _.partial(displaySendStatus, model),
			sortby: _.partial(sortby, model),
		});
	}
}
